export function getTagOptions(tags) {
  return tags?.map(({ tagId, name }) => ({
    value: tagId,
    label: name
  }))
}
